var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.4 850.4",
    style: {
      enableBackground: "new 0 0 850.4 850.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#E0611A;stroke-width:28.3461;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_874",
    transform: "translate(929.529 283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_604",
    className: "st0",
    d: "M-275.7,311.6l-82.2,55.2l-82.2,55.2c-15.9,10.5-35.7-2.8-35.7-24v-31h-245.4 c-14.1-1.2-24.7-13.5-23.8-27.6V237.6c-0.9-14.1,9.7-26.4,23.8-27.6H-476v-32.6c0-21.3,19.8-34.5,35.7-23.8l82.2,54.9l82.2,55.2 c13.2,9.8,16,28.5,6.2,41.7C-271.4,307.8-273.4,309.8-275.7,311.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_606",
    className: "st0",
    d: "M-263.7-54.1V47.5c1,14.2-9.6,26.5-23.8,27.6h-245.2v32c0,21-19.8,34.5-35.7,23.8l-82.2-55.2 L-733,20.7c-13.3-10-15.9-28.9-5.8-42.2c1.7-2.2,3.6-4.2,5.8-5.8l82.2-54.9l82.4-55.2c15.9-10.8,35.7,2.8,35.7,24v31.7h245.2 C-273.3-80.6-262.7-68.3-263.7-54.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.2752589a70d66b4a63210d1ce8ea779f.svg";
export { ForwardRef as ReactComponent };